import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../../../services/apis";
import { Icon, Button } from "semantic-ui-react";
import { Container, Content, Formulario, Title, Input } from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../../../services/auth";
import { toast } from "react-toastify";
import { systemLogs } from "../../../../../../../services/system_logs";
import { useRouter } from "../../../../../../../hooks/router";
import { TestButtonsGroup } from "../styles";
import Cke from "../../../../../../../components/Cke";

const CriarLicao = (props) => {
  const id = props.match.params.id;
  const idCurso = props.match.params.id_curso;
  const [licao, setLicao] = useState({
    ordem: "",
    id_modulo: id,
    id_curso: idCurso,
    titulo: "",
    tipo: "youtube",
    anexo: "",
    opcional: 0,
    ativo: 0,
    // dependencia: "",
    video_alternativo: "",
    libera_data: "",
    descricao: "",
    duracao: 0,
  });
  const [playlist, setPlaylist] = useState();
  const [file, setFile] = useState(null);

  const router = useRouter();

  const uploadAnexo = useCallback(async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", file);
      inputData.append("path", "licoes-anexos");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      setLicao((licao) => ({ ...licao, anexo: url }));

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, [file]);

  useEffect(() => {
    const loadWebseriesPlaylist = async () => {
      api.get("/webseries_playlist").then((res) => {
        setPlaylist(res.data);
      });
    };

    loadWebseriesPlaylist();
  }, []);

  const getTesteByJSID = useCallback(async (js_id) => {
    try {
      const { teste } = (await api.get(`testes/js-id/${js_id}`)).data;

      return teste;
    } catch (err) {
      return null;
    }
  }, []);

  const handleCreateTeste = useCallback(async () => {
    window.open(`/admin/ead/testes/criar?id_licao=${licao.id}`);
  }, [licao]);

  const handleUpdateTeste = useCallback(async () => {
    if (!licao.anexo.includes("teste://")) {
      return;
    }

    const js_id = licao.anexo.replace("teste://", "");
    const teste = await getTesteByJSID(js_id);

    if (!teste) {
      return;
    }

    window.open(`/admin/ead/testes/${teste.id}?id_licao=${licao.id}`);
  }, [licao]);

  const handleSearchTeste = useCallback(async () => {
    window.open(`/admin/ead/testes?id_licao=${licao.id}`);
  }, [licao]);

  const create = useCallback(async () => {
    try {
      const payload = {
        ordem: licao.ordem || null,
        id_modulo: id,
        id_curso: idCurso,
        titulo: licao.titulo,
        tipo: licao.tipo,
        anexo: licao.anexo,
        opcional: licao.opcional,
        ativo: licao.ativo,
        // dependencia: licao.dependencia,
        video_alternativo: licao.video_alternativo,
        libera_data: licao.libera_data || null,
        descricao: licao.descricao,
        duracao: licao.duracao,
      };

      const res = await api.post(`admin/licao`, payload);

      await systemLogs(
        "cursos",
        `criou o licao de id=${res.data.id} do curso de id=${idCurso}`
      );

      swal("Lição criado com sucesso", "", "success").then(() => {
        router.push(`/admin/ead/cursos/${idCurso}/modulos/${id}/licoes`);
      });
    } catch (err) {
      console.error(err);

      swal(
        "Não foi possível criar a lição",
        "Preencha todos os campos obrigatórios",
        "error"
      );
    }
  }, [licao, idCurso]);


  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>
            <h1> Adicionar lição </h1>
          </Title>
          <Formulario
            onSubmit={(e) => {
              e.preventDefault();
              create();
            }}
          >
            <label>
              <span>* Titulo: </span>
              <Input
                placeholder={"Título da Lição"}
                type="text"
                value={licao.titulo}
                onChange={(e) => setLicao({ ...licao, titulo: e.target.value })}
              />
            </label>

            <label>
              <span>* Tipo: </span>
              <select
                id="tipo"
                onChange={(e) => setLicao({ ...licao, tipo: e.target.value })}
                defaultValue={licao.tipo}
              >
                <option value="apresentacao">📎 Apresentação de Slides</option>
                <option value="arquivo">📄 Arquivo</option>
                <option value="file-sender">
                  🔗 📄 Envio de Arquivo (Pelo aluno)
                </option>
                <option value="feedback">💬 Feedback do Couch</option>
                <option value="embed">💻 Incorporar</option>
                <option value="linkYT">🔗🎬 Link para vídeo do Youtube</option>
                <option value="link">🔗 Link</option>
                <option value="expectativa">🔍 Pesquisa de Expectativa</option>
                <option value="pesquisa">📈 Pesquisa de Satisfação</option>
                <option value="teste">💬 Teste - teste</option>
                <option value="aovivo">📡 Transmissão Ao Vivo</option>
                <option value="video">🎬 Vídeo</option>
                <option value="youtube">🎬 Vídeo do Youtube</option>
                <option value="youtubelive">📡 Live do Youtube</option>
                <option value="manualbordo">💬 Manual de Bordo </option>
                <option value="certificado"> Certificado Interno </option>
                <option value="form_mba">📄 Forms MBA </option>
              </select>
            </label>

            {licao.tipo === "teste" && (
              <TestButtonsGroup>
                <label>
                  <Button as="a" href={`/admin/ead/testes/criar?id_licao=${licao.id}`}>Criar</Button>
                </label>

                {licao.anexo.includes("teste://") && (
                  <label>
                    <Button onClick={handleUpdateTeste}>Editar</Button>
                  </label>
                )}

                <label>
                  <Button as="a" href={`/admin/ead/testes?id_licao=${licao.id}`}>Procurar</Button>
                </label>
              </TestButtonsGroup>
            )}

            {licao.tipo === "manualbordo" && (
              <label>
                <span>
                  Selecione a série de lives abaixo.
                  <b>
                    {" "}
                    [ Caso queira adicionar um link, basta selecionar a opção{" "}
                    <h3> "Link Independente" </h3> ]
                  </b>
                </span>
                <select
                  onChange={(e) =>
                    setLicao({ ...licao, anexo: e.target.value })
                  }
                >
                  <option value={null}> Link Independente </option>
                  {playlist?.map((item, key) => (
                    <option
                      value={`manualbordo://${item.link_manualbordo}`}
                      key={key}
                    >
                      {item.nome}
                    </option>
                  ))}
                </select>
              </label>
            )}

            <label>
              <span> Anexo: </span>
              {licao.anexo?.split("manualbordo://")[1] === undefined ? (
                <Input
                  type="text"
                  value={licao.anexo}
                  onChange={(e) =>
                    setLicao({ ...licao, anexo: e.target.value })
                  }
                  placeholder={"Link do Anexo"}
                />
              ) : (
                <Input
                  readOnly={true}
                  type="text"
                  value={licao.anexo.split("manualbordo://")[1]}
                  onChange={(e) =>
                    setLicao({ ...licao, anexo: e.target.value })
                  }
                  placeholder={"Link do Anexo"}
                />
              )}
            </label>

            <label>
              <span> Arquivo do Anexo: </span>

              <Input
                readOnly={true}
                type="file"
                // value={file}
                onChange={(e) => setFile(e.target.files[0])}
                placeholder={"URL do arquivo"}
              />

              <Button type="button" onClick={uploadAnexo}>
                Upload
              </Button>
            </label>

            <label>
              <span> Video Alternativo: </span>
              <Input
                type="text"
                value={licao.video_alternativo}
                onChange={(e) =>
                  setLicao({ ...licao, video_alternativo: e.target.value })
                }
                placeholder={"Link para o vídeo alternativo"}
              />
            </label>

            <label>Descrição:</label>
            <Cke
              default={licao.descricao}
              onBlur={(value) => setLicao({ ...licao, descricao: value })}
            />

            <label>
              <span> Duração (minutos):</span>
              <Input
                type="number"
                value={licao.duracao}
                onChange={(e) =>
                  setLicao({ ...licao, duracao: e.target.value })
                }
              />
            </label>

            <label>
              <span> Data de Liberação:</span>
              <Input
                type="date"
                value={licao.libera_data}
                onChange={(e) =>
                  setLicao({ ...licao, libera_data: e.target.value })
                }
              />
            </label>

            <label>
              <span> Ordem: </span>
              <Input
                type="text"
                value={licao.ordem}
                onChange={(e) => setLicao({ ...licao, ordem: e.target.value })}
                placeholder={"Ordem"}
              />
            </label>

            <label>
              <span>* Liberado: </span>
              <select
                value={licao.ativo}
                onChange={(e) => setLicao({ ...licao, ativo: e.target.value })}
              >
                <option value={"0"}> Trancado </option>
                <option value={"1"}> Liberado </option>
              </select>
            </label>

            <label>
              <span>* É opcional ? </span>
              <select
                value={licao.opcional}
                onChange={(e) =>
                  setLicao({ ...licao, opcional: e.target.value })
                }
              >
                <option value={"1"}> Sim </option>
                <option value={"0"}> Não </option>
              </select>
            </label>

            <button type={"submit"}> Cadastrar </button>
          </Formulario>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CriarLicao);
